import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as EventEmitter from 'events';
import { createStore } from '../store';
import { changeLogin } from '../actions/login';
import { reset } from '../actions/authentication';
import { EEventType } from '../types/events';
import { EAuthMode, EAuthStatus } from '../../browser/types/mrOAuth';
import { MR_OAUTH_CLIENT_ID } from '../constants/mrOAuth';
import { changeTab } from '../actions/tabs';
import { setState } from '../actions/state';
import { changeView } from '../actions/view';
import { authenticate as mrOAuthAuthenticate } from '../actions/mrOAuth';
import { loadMROAuth } from '../../browser/utils/loadMROAuth';
import { trackMROAuthClosed, trackMROAuthShown } from '../utils/tracking';

var AuthenticationContext = /*#__PURE__*/function () {
  function AuthenticationContext(store, emitter) {
    _classCallCheck(this, AuthenticationContext);

    _defineProperty(this, "store", void 0);

    _defineProperty(this, "emitter", void 0);

    this.store = store;
    this.emitter = emitter;
  }

  _createClass(AuthenticationContext, [{
    key: "state",
    get: function get() {
      return this.store.getState();
    },
    set: function set(state) {
      this.store.dispatch(setState(state));
    }
  }, {
    key: "setTab",
    value: function setTab(tab) {
      this.store.dispatch(changeTab(tab));
    }
  }, {
    key: "setView",
    value: function setView(view, data) {
      this.store.dispatch(changeView(view, data));
    }
  }, {
    key: "resetAuthentication",
    value: function resetAuthentication() {
      this.store.dispatch(reset());
    }
  }, {
    key: "setAuthenticationLogin",
    value: function setAuthenticationLogin(login) {
      this.store.dispatch(changeLogin(login));
    }
  }, {
    key: "showMROAuthOneTap",
    value: function showMROAuthOneTap() {
      var _this = this;

      return loadMROAuth().then(function (MR) {
        MR.logout();
        MR.init({
          clientId: MR_OAUTH_CLIENT_ID,
          mode: EAuthMode.OneTap,
          ttlCloseState: 0,
          onunavailable: function onunavailable(info) {
            _this.emitter.emit(EEventType.MROAuthUnavailable, info);
          },
          onshow: function onshow(info) {
            trackMROAuthShown();

            _this.emitter.emit(EEventType.MROAuthShown, info);
          },
          onclose: function onclose(info) {
            trackMROAuthClosed();

            _this.emitter.emit(EEventType.MROAuthClosed, info);
          },
          onlogin: function onlogin(state) {
            if (state.status === EAuthStatus.Connected) {
              _this.store.dispatch(mrOAuthAuthenticate({
                email: state.user.email,
                accessToken: state.access_token
              }));
            } else {
              throw new Error('Unexpected AuthStatus on login');
            }
          }
        });
      });
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "on",
    value: function on(type, handler) {
      this.emitter.addListener(type, handler);
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "off",
    value: function off(type, handler) {
      this.emitter.removeListener(type, handler);
    }
  }]);

  return AuthenticationContext;
}();

export function createContext(options, preloadedState) {
  var context = _extends({}, options);

  var emitter = new EventEmitter();
  var store = createStore({
    context: _objectSpread(_objectSpread({}, context), {}, {
      emitter: emitter
    }),
    preloadedState: preloadedState
  });
  return new AuthenticationContext(store, emitter);
}